export default __webpack_public_path__ + "static/media/MaterialIcons.120b4c7b.ttf";